import { render, staticRenderFns } from "./PageVmLoading.vue?vue&type=template&id=56e7096b&"
import script from "./PageVmLoading.vue?vue&type=script&lang=js&"
export * from "./PageVmLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports